// Generated by Melange

import * as Belt__Belt_Option from "melange.belt/belt_Option.js";
import * as Buhta_core__Grpc from "../../../../packages/core/lib/Grpc.js";
import * as Buhta_core__GrpcState from "../../../../packages/core/lib/GrpcState.js";
import * as Buhta_payrollapis__Buhta_payroll_v1alpha1_payout_service from "../../../../proto/payrollapis/gen/buhta_payroll_v1alpha1_payout_service.js";
import * as Buhta_payrollapis__Buhta_payroll_v1alpha2_employee_service from "../../../../proto/payrollapis/gen/buhta_payroll_v1alpha2_employee_service.js";
import * as Buhta_payrollapis__Buhta_payroll_v1alpha2_employment_service from "../../../../proto/payrollapis/gen/buhta_payroll_v1alpha2_employment_service.js";
import * as Curry from "melange.js/curry.js";

const Employee = {};

const Employment = {};

const Payout = {};

function toCreateRequest(form) {
  return Curry._2(Buhta_payrollapis__Buhta_payroll_v1alpha2_employee_service.Buhta.Payroll.V1alpha2.CreateEmployeeRequest.make, form, undefined);
}

function toUpdateRequest(id, form) {
  return Curry._3(Buhta_payrollapis__Buhta_payroll_v1alpha2_employee_service.Buhta.Payroll.V1alpha2.UpdateEmployeeRequest.make, id, form, undefined);
}

const EmployeeForm = {
  toCreateRequest: toCreateRequest,
  toUpdateRequest: toUpdateRequest
};

function toUpdateRequest$1(id, form) {
  return Curry._3(Buhta_payrollapis__Buhta_payroll_v1alpha2_employment_service.Buhta.Payroll.V1alpha2.UpdateEmploymentRequest.make, id, form, undefined);
}

const EmploymentForm = {
  toUpdateRequest: toUpdateRequest$1
};

const apiEndpointPrefix = "/payroll";

function view(tenant, expandOpt, id, param) {
  const expand = expandOpt !== undefined ? expandOpt : /* [] */ 0;
  const request = Curry._3(Buhta_payrollapis__Buhta_payroll_v1alpha2_employee_service.Buhta.Payroll.V1alpha2.GetEmployeeRequest.make, id, expand, undefined);
  return Buhta_core__GrpcState.unwrapPromiseResponse((function (response) {
    return Belt__Belt_Option.getExn(response.employee);
  }), Buhta_core__Grpc.makeRpc(undefined, request, Buhta_payrollapis__Buhta_payroll_v1alpha2_employee_service.Buhta.Payroll.V1alpha2.EmployeeService.getEmployee, undefined, undefined, tenant, apiEndpointPrefix + Buhta_payrollapis__Buhta_payroll_v1alpha2_employee_service.Buhta.Payroll.V1alpha2.EmployeeService.GetEmployee.name, undefined, undefined));
}

function grid(tenant, params, param) {
  const request = Curry._2(Buhta_payrollapis__Buhta_payroll_v1alpha2_employee_service.Buhta.Payroll.V1alpha2.ListEmployeesRequest.make, Buhta_core__GrpcState.makeGridRequest(params, undefined), undefined);
  return Buhta_core__GrpcState.unwrapPromiseResponse((function (response) {
    return response.employees;
  }), Buhta_core__Grpc.makeRpc(undefined, request, Buhta_payrollapis__Buhta_payroll_v1alpha2_employee_service.Buhta.Payroll.V1alpha2.EmployeeService.listEmployees, undefined, undefined, tenant, apiEndpointPrefix + Buhta_payrollapis__Buhta_payroll_v1alpha2_employee_service.Buhta.Payroll.V1alpha2.EmployeeService.ListEmployees.name, undefined, undefined));
}

function create(tenant, form) {
  return Buhta_core__GrpcState.unwrapPromiseResponse((function (response) {
    return Belt__Belt_Option.getExn(response.employee);
  }), Buhta_core__Grpc.makeRpc(undefined, toCreateRequest(form), Buhta_payrollapis__Buhta_payroll_v1alpha2_employee_service.Buhta.Payroll.V1alpha2.EmployeeService.createEmployee, undefined, undefined, tenant, apiEndpointPrefix + Buhta_payrollapis__Buhta_payroll_v1alpha2_employee_service.Buhta.Payroll.V1alpha2.EmployeeService.CreateEmployee.name, undefined, undefined));
}

function update(tenant, id, form) {
  return Buhta_core__GrpcState.unwrapPromiseResponse((function (response) {
    return Belt__Belt_Option.getExn(response.employee);
  }), Buhta_core__Grpc.makeRpc(undefined, toUpdateRequest(id, form), Buhta_payrollapis__Buhta_payroll_v1alpha2_employee_service.Buhta.Payroll.V1alpha2.EmployeeService.updateEmployee, undefined, undefined, tenant, apiEndpointPrefix + Buhta_payrollapis__Buhta_payroll_v1alpha2_employee_service.Buhta.Payroll.V1alpha2.EmployeeService.UpdateEmployee.name, undefined, undefined));
}

const EmployeeService = {
  view: view,
  grid: grid,
  create: create,
  update: update
};

function update$1(tenant, id, form) {
  return Buhta_core__GrpcState.unwrapPromiseResponse((function (response) {
    return Belt__Belt_Option.getExn(response.employment);
  }), Buhta_core__Grpc.makeRpc(undefined, toUpdateRequest$1(id, form), Buhta_payrollapis__Buhta_payroll_v1alpha2_employment_service.Buhta.Payroll.V1alpha2.EmploymentService.updateEmployment, undefined, undefined, tenant, apiEndpointPrefix + Buhta_payrollapis__Buhta_payroll_v1alpha2_employment_service.Buhta.Payroll.V1alpha2.EmploymentService.UpdateEmployment.name, undefined, undefined));
}

const EmploymentService = {
  update: update$1
};

function view$1(tenant, expandOpt, id, param) {
  const expand = expandOpt !== undefined ? expandOpt : /* [] */ 0;
  const request = Curry._3(Buhta_payrollapis__Buhta_payroll_v1alpha1_payout_service.Buhta.Payroll.V1alpha1.GetPayoutRequest.make, id, expand, undefined);
  return Buhta_core__GrpcState.unwrapPromiseResponse((function (response) {
    return Belt__Belt_Option.getExn(response.payout);
  }), Buhta_core__Grpc.makeRpc(undefined, request, Buhta_payrollapis__Buhta_payroll_v1alpha1_payout_service.Buhta.Payroll.V1alpha1.PayoutService.getPayout, undefined, undefined, tenant, apiEndpointPrefix + Buhta_payrollapis__Buhta_payroll_v1alpha1_payout_service.Buhta.Payroll.V1alpha1.PayoutService.GetPayout.name, undefined, undefined));
}

function grid$1(tenant, params, param) {
  const request = Curry._4(Buhta_payrollapis__Buhta_payroll_v1alpha1_payout_service.Buhta.Payroll.V1alpha1.ListPayoutsRequest.make, undefined, undefined, Buhta_core__GrpcState.makeGridRequest(params, undefined), undefined);
  return Buhta_core__GrpcState.unwrapPromiseResponse((function (response) {
    return response.payouts;
  }), Buhta_core__Grpc.makeRpc(undefined, request, Buhta_payrollapis__Buhta_payroll_v1alpha1_payout_service.Buhta.Payroll.V1alpha1.PayoutService.listPayouts, undefined, undefined, tenant, apiEndpointPrefix + Buhta_payrollapis__Buhta_payroll_v1alpha1_payout_service.Buhta.Payroll.V1alpha1.PayoutService.ListPayouts.name, undefined, undefined));
}

const PayoutService = {
  view: view$1,
  grid: grid$1
};

export {
  Employee,
  Employment,
  Payout,
  EmployeeForm,
  EmploymentForm,
  EmployeeService,
  EmploymentService,
  PayoutService,
}
/* Buhta_core__Grpc Not a pure module */
